/**
 * Finance salary companies — loaded from API (`financeSalaryCompanies` table).
 * @see financeSalaryCompaniesApi.js
 */
import {
  createFinanceSalaryCompanyApi,
  fetchFinanceSalaryCompanies,
  fetchFinanceSalaryCompanyById,
} from "./financeSalaryCompaniesApi";
import {
  buildFinanceSalaryCompanyDrawerOptions,
  getDefaultSalaryCompanyOptionValue,
} from "./financeDefaultSalaryCompany";

export { FINANCE_SALARY_COMPANIES_UPDATED_EVENT } from "./financeSalaryCompaniesConstants";

export const readFinanceSalaryCompanies = fetchFinanceSalaryCompanies;

export const getFinanceSalaryCompanyById = fetchFinanceSalaryCompanyById;

export const getFinanceSalaryCompanyLabel = async (companyId) => {
  const profile = await fetchFinanceSalaryCompanyById(companyId);
  return profile?.companyName?.trim() || "";
};

export const getFinanceSalaryCompanyOptions = async () => {
  const companies = await fetchFinanceSalaryCompanies();
  return buildFinanceSalaryCompanyDrawerOptions(companies);
};

export { getDefaultSalaryCompanyOptionValue };

export const createFinanceSalaryCompany = createFinanceSalaryCompanyApi;

/** Sync helpers for components that already have the companies list in memory. */
export const getFinanceSalaryCompanyLabelSync = (companyId, companies = []) => {
  if (companyId == null || companyId === "") return "";
  const id = String(companyId);
  const profile = companies.find((row) => String(row.id) === id);
  return profile?.companyName?.trim() || "";
};

export const getFinanceSalaryCompanyOptionsSync = (companies = []) =>
  companies.map((profile) => ({
    value: String(profile.id),
    label: profile.companyName?.trim() || `Company ${profile.id}`,
  }));
